export default "<div id=\"revenueSubscriptionContainer\">\n\n</div>";